import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { REQUIRED } from 'constants/errors';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { setToStartOfMonth } from 'helpers/date';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { CitizenshipIntlItemModel } from '../types';

export const pvqForeignPassportInternationalValidator: ValidateJSModel<CitizenshipIntlItemModel> = {

  CountryTraveledTo: {
    presence: true,
    location: {
      requireStreet: false,
      requireState: false,
      requireCity: false,
      requireZipCode: false,
      validator: pvqLocationModelValidator
    }
  },

  WhenTraveled: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Days: {
    hasValue: {
      validator: {
        inclusion: ['0-1', '1-7', '8-14', '15-30', 'Over 30', 'Many short trips', 'Other'],
      },
    },
  },

  Purpose: {
    presence: true,
    array: {
      length: { minimum: 1, message: REQUIRED },
      validator: { inclusion: ['Business', 'Volunteer', 'Education', 'Tourism', 'Conference', 'Family', 'Other'] },
    }
  },

  WhyTravel: (value, attributes) => {
    if (attributes.Purpose?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  Searched: { presence: true, hasValue: { validator: hasYesOrNo } },

  SearchedExplain: (value, attributes) => {
    if (attributes.Searched?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  PoliceEncounters: { presence: true, hasValue: { validator: hasYesOrNo } },

  PoliceEncountersExplain: (value, attributes) => {
    if (attributes.PoliceEncounters?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  ForeignContact: { presence: true, hasValue: { validator: hasYesOrNo } },

  ForeignContactExplain: (value, attributes) => {
    if (attributes.ForeignContact?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  SecurityIncidents: { presence: true, hasValue: { validator: hasYesOrNo } },

  SecurityIncidentsExplain: (value, attributes) => {
    if (attributes.SecurityIncidents?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  Interest: { presence: true, hasValue: { validator: hasYesOrNo } },

  InterestExplain: (value, attributes) => {
    if (attributes.Interest?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  InfoGrab: { presence: true, hasValue: { validator: hasYesOrNo } },

  InfoGrabExplain: (value, attributes) => {
    if (attributes.InfoGrab?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  Threatened: { presence: true, hasValue: { validator: hasYesOrNo } },

  ThreatenedExplain: (value, attributes) => {
    if (attributes.Threatened?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

};
